module.exports = __webpack_public_path__ + "static/media/18_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_04.5927babc.jpg";